// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconMegaphone = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M16 18V4h-2L7 7H2v8h1.4L2 19h3.6L7 15l7 3zm-8-4.554V8.554L14 6v10zM4 13V9h2v4z" />,
    <path d="M23.078 12h-4v-2h4zm-4.371-3.464l2.828-2.829-1.414-1.414-2.828 2.828zm-1.414 6.343l1.414-1.415 2.828 2.829-1.414 1.414z" />
  );
export default SvgIconMegaphone;
